export const COLOR_WHITE = { displayName: 'Vit', hex: '#ffffff' };
export const COLOR_BLACK = { displayName: 'Svart', hex: '#000000' };
export const COLOR_GRAY = { displayName: 'Grå', hex: '#808080' };
export const COLOR_SILVER = { displayName: 'Silver', hex: '#c0c0c0' };
export const COLOR_BLUE = { displayName: 'Blå', hex: '#0000ff' };
export const COLOR_RED = { displayName: 'Röd', hex: '#ff0000' };
export const COLOR_BROWN = { displayName: 'Brun', hex: '#a52a2a' };
export const COLOR_GREEN = { displayName: 'Grön', hex: '#008000' };
export const COLOR_ORANGE = { displayName: 'Orange', hex: '#ffa500' };
export const COLOR_YELLOW = { displayName: 'Gul', hex: '#ffff00' };
export const COLOR_PURPLE = { displayName: 'Lila', hex: '#800080' };
export const COLOR_BEIGE = { displayName: 'Beige', hex: '#f5f5dc' };

export const getHexColorFromDisplayName = (displayName: string) => {
  switch (displayName) {
    case COLOR_WHITE.displayName:
      return COLOR_WHITE.hex;
    case COLOR_BLACK.displayName:
      return COLOR_BLACK.hex;
    case COLOR_GRAY.displayName:
      return COLOR_GRAY.hex;
    case COLOR_SILVER.displayName:
      return COLOR_SILVER.hex;
    case COLOR_BLUE.displayName:
      return COLOR_BLUE.hex;
    case COLOR_RED.displayName:
      return COLOR_RED.hex;
    case COLOR_BROWN.displayName:
      return COLOR_BROWN.hex;
    case COLOR_GREEN.displayName:
      return COLOR_GREEN.hex;
    case COLOR_ORANGE.displayName:
      return COLOR_ORANGE.hex;
    case COLOR_YELLOW.displayName:
      return COLOR_YELLOW.hex;
    case COLOR_PURPLE.displayName:
      return COLOR_PURPLE.hex;
    case COLOR_BEIGE.displayName:
      return COLOR_BEIGE.hex;
    default:
      return '#fff';
  }
};
